import { Link } from "react-router-dom";
import HomeVideopopup from "./HomeVideopopup";
import React, { useState } from "react";

export default function HomeVideo() {
  const [modalShow, setModalShow] = useState(false);

  return ( 
    <>
    <section className="homepage-video">
        <div className="home-newvideo-box">
            <div>
                <h4 className='heading'>Welcome to Lucknow Public School</h4>
                <Link className="video-play-button" onClick={() => setModalShow(true)}><span></span></Link> 
            </div>
        </div>
              
        <img src="/image/video-thumb.webp" className='img-responsive' alt="Video" loading="lazy"/>
    </section> 
    
    <HomeVideopopup show={modalShow} onHide={() => setModalShow(false)}/>
    </>
  )
}
